import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
import CampaignInformation from "../campaignInformation/CampaignInformation";
import UserManagementList from "../userManagement/UserManagementList";
import Organization from "../organization/Organization";
import Billing from "../billing/Billing";
import CrmIntegration from "../crmIntegration/CrmIntegration";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import { Col, Row } from "reactstrap";
import Button from "@mui/material/Button";
import "./Settings.css";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
class Settings extends Component {
  header = store.getState().header.header;
  countryListArray = store.getState().staticData.countryList;
  messageTypeList = store.getState().staticData.messageTypeList;
  optinCollectionOptionList =
    store.getState().staticData.optinCollectionOptionList;
  optinPermissonMethodList =
    store.getState().staticData.optinPermissonMethodList;
  organizationTypeList = store.getState().staticData.organizationTypeList;
  sendMessageTypeList = store.getState().staticData.sendMessageTypeList;
  selectedTab = store.getState().selectedTab.selectedTab;
  tollfreeNumberPurchased =
    store.getState().appUserData.appUserData.isTollfreeNumberPurchased;
  tollFreeNumberError =
    store.getState().appUserData.appUserData.tollFreeNumberError;
  menuList = store.getState().appUserData.appUserData.appuser?.profile?.menus;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;
  tollFreeNumberStatus = store.getState().appUserData.tollFreeNumberStatus;

  breadCrumb = [{ pageid: "", uiname: "Account Settings" }];
  constructor(props) {
    super(props);
    let pageId = "";
    if (props.state) {
      pageId = props.state.pageId;
    }
    let showCmpaigningInfoModal = false;

    if (this.tollfreeNumberPurchased === false) {
      if (pageId === "login") {
        showCmpaigningInfoModal = true;
      }
    } else {
      showCmpaigningInfoModal = false;
    }
    this.state = {
      pageId: pageId,
      selectedTab: this.selectedTab,
      sendTextCanada: "",
      showPassword: false,
      organizationTypeList: [],
      campaignDescription: "",
      keyword: "",
      sampleText1: "",
      sampleText2: "",
      optInPermissionMethod: "",
      textPerMonth: "",
      businessIndustry: "",
      sendMessageType: "",
      businessTypeList: [],
      businessType: "",
      planCategoryList: [],
      selectedTabColor: "#eac891",
      planList: [],
      messageType: "",
      isTollFreeNumberPurchased: showCmpaigningInfoModal,
      childMenus: this.menuList
        .filter((menu) => menu.menuid === "Settings")[0]
        .childMenus.sort((a, b) => a.displaysequence - b.displaysequence),
      // messageTypeList: [],
    };
  }


  componentWillReceiveProps() {
    const selectedTab = store.getState().selectedTab.selectedTab;
    this.setState({
      selectedTab: selectedTab,
    });
  }

  setKey = (tab) => {
    if (this.state.selectedTab === tab) {
      this.setState((prevState) => ({
        refreshKey: (prevState.refreshKey || 0) + 1,
      }));
    } else {
      this.setState({
        selectedTab: tab,
      });
    }
  };

  tollfreeNumberPurchasedToggle() {
    this.setState({ isTollFreeNumberPurchased: false });
  }

  addTollFreeNumberModal() {
    store.dispatch(SelectedTabAction.setSelectedTab(1));

    this.setState({
      // viewTwilioNumber: false,
      // addTwilioNumber: true,
      // showAddToTollFreeNumber: false,
      selectedTab: 1,
      isTollFreeNumberPurchased: false,
    });
  }

  renderTabContent = (menu) => {
    switch (menu.menuid) {
      case "Organization":
        return (
          <Organization
            action="view"
            pageId={this.state.pageId}
          />
        );

      case "OrgCampaigningInfo":
        return <CampaignInformation action="view" />

      case "BillingInfo":
        return <Billing action="view" />;

      case "CrmIntegration":
        return <CrmIntegration action="view" />;

      case "UserMgmt":
        return <UserManagementList key={this.state.refreshKey} action="userList" />;

      default:
        return null;
    }
  };

  render() {
    const activeMenus = this.state.childMenus
      ?.filter((m) => m.isactive)
      ?.sort((a, b) => a.displaysequence - b.displaysequence);

    const isSetupIncomplete = ["Rejected"]?.includes(this.tollFreeNumberStatus)
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          name="View and manage your account settings"
        />
        <div>
          <div className="authentication-inner row m-0">
            <div className="col-md-12 p-0">
              <Tabs
                selectedIndex={this.state.selectedTab}
                onSelect={(index) => this.setKey(index)}
              >
                <TabList
                  style={{ listStyle: "none", margin: "0" }}
                  className="text-start d-flex flex-wrap justify-content-start settingTabList ps-0"
                >
                  {activeMenus.map((menu) => {
                    const shouldHighlight =
                      isSetupIncomplete &&
                      ["Company Details", "Use Case"]?.includes(menu.uiname);

                    return (
                      <Tab
                        key={menu.id}
                        className={`tabSetting hoverTab ${shouldHighlight ? "tabSetting-danger tabSetting-danger-hoverTab fw-bold" : ""
                          }`}
                      >
                        {menu.uiname}
                      </Tab>
                    );
                  })}
                </TabList>

                {activeMenus.map((menu) => (
                  <TabPanel key={menu.id}>
                    {this.renderTabContent(menu)}
                  </TabPanel>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
        <Dialog
          open={this.state.isTollFreeNumberPurchased}
          onClose={this.tollfreeNumberPurchasedToggle.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "1em" }}>
            <Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <span
                  style={{
                    color: "#162c50",
                    margin: "1.1em 1em",
                    padding: "1em",
                  }}
                >
                  {" "}
                  {this.tollFreeNumberError ? this.tollFreeNumberError : ""}
                </span>{" "}
                <br /> <br />
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              marginTop: "1em",
              padding: "2em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="small"
              style={{
                // float: 'right',
                background: "#ef6603",
                color: "#fff",
              }}
              onClick={this.addTollFreeNumberModal.bind(this)}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withRouter(Settings);
